module.exports = __webpack_public_path__ + "static/media/checkpoint@3x.d1f71793.jpg";